import React from 'react';
import { LiaCoinsSolid } from 'react-icons/lia';
import './CoinIcon.css';

const CoinIcon = ({ className = '', title = 'Coins' }) => {
  return (
    <LiaCoinsSolid
      className={`coin-icon-inline ${className}`.trim()}
      aria-hidden="true"
      focusable="false"
      title={title}
    />
  );
};

export default CoinIcon;

